module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_6005.4f9d4a1f.png";